<template>
  <v-col
    cols="12"
    sm="12"
    class="request-container"
    @click="$emit('show-request')"
  >
    <v-card
      style="border-radius: 0; padding-bottom: 12px"
      v-bind:class="{ urgent: techReq.request.is_urgency }"
    >
      <v-row style="margin: 0; margin-bottom: 12px">
        <v-col cols="5" style="padding: 0">
          <div :style="visitTypeStyle">
            {{ techReq.request.status_request.description }}
          </div>
        </v-col>
        <v-col
          v-if="$store.state.app_display_scheme"
          cols="1"
          style="
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <v-img
            v-if="techReq.request.scheme == 'rvl'"
            class="ml-2"
            contain
            src="../icons/asistencia.png"
            height="20"
          ></v-img>
          <v-img
            v-if="techReq.request.scheme == 'asistencia'"
            class="ml-2"
            contain
            src="../icons/asistencia.png"
            height="20"
          ></v-img>
          <v-img
            v-if="techReq.request.scheme == 'cliente-final'"
            class="ml-2"
            contain
            src="../icons/clientefinal.png"
            height="20"
          ></v-img>
          <v-img
            v-if="techReq.request.scheme == 'corpo'"
            class="ml-2"
            contain
            src="../icons/corporativo.png"
            height="20"
          ></v-img>
          <v-img
            v-if="techReq.request.scheme == 'fletes'"
            class="ml-2"
            contain
            src="../icons/fletes.png"
            height="20"
          ></v-img>
          <v-img
            v-if="techReq.request.scheme == 'inmobiliaria'"
            class="ml-2"
            contain
            src="../icons/inmobiliaria.png"
            height="20"
          ></v-img>
        </v-col>
        <v-col cols="3" style="padding: 0; display: flex; align-items: center">
          <div style="margin-left: 12px; font-weight: bold">
            ID: {{ techReq.request.id }}
          </div>
        </v-col>
      </v-row>
      <v-row
        align="center"
        style="margin: 0 12px; color: #ff5252"
        v-if="techReq.request.is_urgency"
      >
        <b>PEDIDO URGENTE</b>
      </v-row>
      <v-row align="center" style="margin: 0 12px; font-weight: bold">
        {{ techReq.request.service.name }}
      </v-row>
      <v-row align="center" style="margin: 0 12px">
        {{ techReq.request.neighborhood.city.name.toUpperCase() }} -
        {{ techReq.request.full_address }}
      </v-row>
    </v-card>
  </v-col>
</template>
<script>
export default {
  name: "request-item",
  props: {
    techReq: Object,
  },
  computed: {
    visitTypeStyle: function () {
      const style = `
        background-color: #1B203F;
        color:white;
        padding: 6px;
        font-size: 14px;
        display: flex;
        justify-content: center;
      `;
      return style;
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .request-container {
    padding: 12px 0;
    background: #eeeeee;
  }
}
.urgent {
  background-color: #fffbcb !important;
}
</style>
